import { useCallback, useMemo } from 'react';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import { VALUATIONS_APPROACH_QUERY_PARAM } from 'pages/ValuationsAllocation/common/constants/valuations';
import { setQueryString } from 'utillities';

const useApproachQueryParam = () => {
  const history = useHistory();
  const location = useLocation();
  const { pathname, search } = location;

  const parsedQuery = useMemo(() => queryString.parse(search), [search]);
  const { [VALUATIONS_APPROACH_QUERY_PARAM]: approachId } = parsedQuery;

  const setApproachQueryParam = useCallback(
    (id: string) => {
      if (approachId !== id) {
        setQueryString({
          history,
          paramName: VALUATIONS_APPROACH_QUERY_PARAM,
          paramValue: id,
          pathname,
          searchParams: queryString.stringify(parsedQuery),
          shouldPushPath: true,
        });
      }
    },
    [approachId, history, parsedQuery, pathname]
  );

  return {
    approachId,
    setApproachQueryParam,
  };
};

export default useApproachQueryParam;
